export default [
  {
    path: '/fishermen',
    name: 'fishermen',
    component: () => import('@/views/pages/record-catch/fisherman/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.fishermen',
      resource: 'record_catch',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fishermen/add',
    name: 'add-fisherman',
    component: () => import('@/views/pages/record-catch/fisherman/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.fishermen',
      resource: 'record_catch',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fishermen/modify/:id',
    name: 'modify-fisherman',
    component: () => import('@/views/pages/record-catch/fisherman/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.fishermen',
      resource: 'record_catch',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
